import {HrStatusEnum} from '@/services/api-clients';

export function driverHrTagIconFilter(tag: HrStatusEnum): string {
  switch(tag) {
    case HrStatusEnum.Reported: return 'mdi-file-document-check';
    case HrStatusEnum.Active: return 'mdi-account-check';
    case HrStatusEnum.HadPayout: return 'mdi-cash-check';
    case HrStatusEnum.ToBeReported: return 'mdi-bullhorn';
    case HrStatusEnum.ToBeRemoved: return 'mdi-file-document-arrow-right';
    case HrStatusEnum.Removed: return 'mdi-close-circle';
    case HrStatusEnum.MissingData: return 'mdi-exclamation-thick'
    case HrStatusEnum.Other: return 'mdi-dots-horizontal-circle';
    case HrStatusEnum.StudentCardRequired: return 'mdi-badge-account-alert';
    case HrStatusEnum.StudentCardUploaded: return 'mdi-badge-account';
    case HrStatusEnum.Bailiff: return 'mdi-scale-unbalanced';
    case HrStatusEnum.B2B: return 'mdi-handshake';
    case HrStatusEnum.WithoutPayout: return 'mdi-cash-off';
    case HrStatusEnum.ActivePayoutCurrentMonth: return 'mdi-calendar-month';
    case HrStatusEnum.ActivePayoutPreviousMonth: return 'mdi-calendar-arrow-left';
    case HrStatusEnum.MissingTaxOffice: return 'mdi-briefcase';
    case HrStatusEnum.MissingCurrentInsurance: return 'mdi-shield';
    case HrStatusEnum.MissingAnnuitantCard: return 'mdi-account-injury';
    case HrStatusEnum.MissingDisabilityCertificate: return 'mdi-wheelchair';
    case HrStatusEnum.MissingInsuranceFromDuty: return 'mdi-account-tie-hat';
    case HrStatusEnum.MissingPensionerCard: return 'mdi-human-walker';
    case HrStatusEnum.MissingPesel: return 'mdi-numeric';
    case HrStatusEnum.Resignation: return 'mdi-draw-pen';
    case HrStatusEnum.UnvalidatedContractOfMandate: return 'mdi-text-box-remove';
    case HrStatusEnum.ValidatedContractOfMandate: return 'mdi-text-box-check';
    case HrStatusEnum.UnvalidatedStudentStatus: return 'mdi-account-off';
    case HrStatusEnum.ValidatedStudentStatus: return 'mdi-account-check';
    case HrStatusEnum.TaxSituation: return 'mdi-sack-percent';
    case HrStatusEnum.SiiRequest: return 'mdi-file-document-alert';
    case HrStatusEnum.SiiResignationRequest: return 'mdi-file-document-remove';
    case HrStatusEnum.MissingDriverLicenseNumber: return 'mdi-card-search';
    case HrStatusEnum.ToBeVerifiedInCepik: return 'mdi-shield-search';
    case HrStatusEnum.VerifiedInCepik: return 'mdi-shield-check-outline';
    case HrStatusEnum.VerificationRejectedInCepik: return 'mdi-shield-off';
    case HrStatusEnum.RentOnly: return 'mdi-key-variant';
    case HrStatusEnum.WorkPermitRequired: return 'mdi-passport';
    case HrStatusEnum.ContractOfMandateOtherEmployerToVerify: return 'mdi-file-document-alert-outline';
    case HrStatusEnum.InsuredByOtherPayer: return 'mdi-shield-account';
  }
}
